import React from "react";
import { reviews } from "../mock";
import Stars from "./Stars";
import { CornerDownRight, ExternalLink } from "lucide-react";
import useReveal from "../hooks/useReveal";

function ReviewRow({ r }) {
  return (
    <div className="flex gap-4 border-b border-navy/10 py-6 last:border-0">
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy font-heading font-bold text-white">
        {r.name.charAt(0)}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-navy">{r.name}</p>
        <p className="text-xs text-navy/50">{r.meta}</p>
        <div className="mt-1.5 flex items-center gap-2">
          <Stars value={r.rating} size={14} />
          <span className="text-xs text-navy/50">{r.when}</span>
        </div>
        <p className="mt-2 text-sm leading-relaxed text-navy/75">{r.text}</p>
        {r.photos && (
          <div className="mt-3 flex flex-wrap gap-2">
            {r.photos.map((p, i) => (
              <img key={i} src={p} alt={`${r.name} photo`} className="h-20 w-20 rounded-lg border border-navy/10 object-cover" />
            ))}
          </div>
        )}
        {r.reply && (
          <div className="mt-3 rounded-xl bg-sky/60 p-3">
            <p className="flex items-center gap-1.5 text-xs font-bold text-navy">
              <CornerDownRight size={13} className="text-brand" /> Response from Cyberfit
            </p>
            <p className="mt-1 text-xs leading-relaxed text-navy/70">{r.reply}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default function Reviews({ title = "Customer Reviews", subtitle }) {
  const ref = useReveal();
  const [showAll, setShowAll] = React.useState(false);
  const visible = showAll ? reviews : reviews.slice(0, 9);
  return (
    <section id="reviews" className="bg-white py-16">
      <div ref={ref} className="reveal mx-auto max-w-7xl px-4 lg:px-8">
        <div className="mb-10 flex flex-col items-center text-center">
          <h2 className="font-heading text-3xl font-extrabold text-navy md:text-4xl">{title}</h2>
          {subtitle && <p className="mt-2 text-sm text-navy/60">{subtitle}</p>}
          <a
            href="https://www.google.com/maps/place/Cyberfit+Gym+Equipment"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-1.5 rounded-full border-2 border-navy px-6 py-2.5 text-xs font-bold uppercase tracking-wide text-navy transition-colors hover:bg-navy hover:text-white"
          >
            Read on Google <ExternalLink size={13} />
          </a>
        </div>

        {/* Reviews list */}
        <div className="columns-1 gap-8 sm:columns-2 lg:columns-3">
          {visible.map((r, i) => (
            <div key={i} className="break-inside-avoid">
              <ReviewRow r={r} />
            </div>
          ))}
        </div>

        {!showAll && reviews.length > 9 && (
          <div className="mt-8 text-center">
            <button
              onClick={() => setShowAll(true)}
              className="rounded-full border-2 border-navy px-8 py-3 font-heading text-sm font-bold uppercase tracking-wide text-navy transition-colors hover:bg-navy hover:text-white"
            >
              Show more reviews
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
